import { baseUrl } from '../../config/appsettings';

const AppApiService = {
  // Method for handling the signup API call
  Add: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}App/Create`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Add App error:', error);
      throw new Error('Network error');
    }
  },

  Get: async () => {
    try {
      const apiEndpoint = `${baseUrl}App/Get`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  GetAllAppByUserId: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}App/Get/${data}`; // Complete URL for the test endpoint

      const response = await fetch(apiEndpoint, {
        method: 'GET', // Correctly capitalized method
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  Update: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}App/Update`; // Complete URL for the signup endpoint

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data), // Convert data to JSON
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Update App error:', error);
      throw new Error('Network error');
    }
  },

  Delete: async (data) => {
    try {
      const apiEndpoint = `${baseUrl}App/Delete/${data}`; // Correct URL with `/`

      const response = await fetch(apiEndpoint, {
        method: 'DELETE', // Use DELETE instead of POST
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Delete App error:', error);
      throw new Error('Network error');
    }
  },
  ChangeStatus: async (model) => {
    try {
      const apiEndpoint = `${baseUrl}App/UpdateStatus`;

      const response = await fetch(apiEndpoint, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(model)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error occurred');
      }

      const result = await response.json(); // Parse the JSON response
      return result; // Return response data on success
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

};

export default AppApiService;
